import React, { Component } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Download from '@material-ui/icons/GetApp';
import DeleteIcon from '@material-ui/icons/Delete';
import OpenIcon from '@material-ui/icons/OpenInBrowser';
import DetailsIcon from '@material-ui/icons/List';
import LaunchIcon from '@material-ui/icons/Launch';
import AddIcon from '@material-ui/icons/Add';
import CloudUpload from '@material-ui/icons/CloudUpload';
import styled from 'src/ui/library/styled';

const styles = theme => ({
  vertIcon: {
    transform: 'rotate(90deg)',
    fontSize: '3rem',
    fill: '#C4C4CD',
  },
  icon: {
    marginRight: '1rem',
  },
});

const ITEM_HEIGHT = 48;

class ThreeDotMenuBase extends Component {
  state = {
    anchorEl: null,
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = type => {
    const { handleMenuSelect, tableMeta } = this.props;
    this.setState({ anchorEl: null }, () => {
      handleMenuSelect(type, tableMeta);
    });
  };

  /** should refactor this to receive an child icon element prop from the caller not to be imported directly to here */
  renderIcon = (type, iconClass) => {
    let icon = null;
    if (type === 'package' || type === 'status') icon = <Download className={iconClass} />;
    else if (type === 'delete') icon = <DeleteIcon className={iconClass} />;
    else if (type === 'open') icon = <OpenIcon className={iconClass} />;
    else if (type === 'details') icon = <DetailsIcon className={iconClass} />;
    else if (type === 'view') icon = <LaunchIcon className={iconClass} />;
    else if (type === 'add') icon = <AddIcon className={iconClass} />;
    else if (type === 'upload') icon = <CloudUpload className={iconClass} />;
    return icon;
  };

  render() {
    const { classes, options, rootClassName, handleMenuSelect, tableMeta, tableData, ...otherProps } = this.props;
    const { anchorEl } = this.state;

    return (
      <div
        className={rootClassName || ''}
        onClick={e => {
          e.stopPropagation();
        }}>
        <IconButton aria-label="More" aria-owns={anchorEl ? 'long-menu' : null} aria-haspopup="true" onClick={e => this.handleClick(e)}>
          <MoreVertIcon className={classes.vertIcon} />
        </IconButton>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          getContentAnchorEl={null}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4,
              width: 'auto',
            },
          }}
          {...otherProps}>
          {options.map((option, index) =>
            option ? (
              <MenuItem
                key={option + '-' + index * Math.random()}
                disabled={option.disabled ? option.disabled : false}
                selected={false}
                onClick={this.handleClose.bind(this, option.type)}>
                {this.renderIcon(option.type, classes.icon)}
                {option.title}
              </MenuItem>
            ) : null,
          )}
        </Menu>
      </div>
    );
  }
}

export default styled(ThreeDotMenuBase)(styles);



// WEBPACK FOOTER //
// ./src/ui/library/ThreeDotMenu/ThreeDotMenuBase.js